import * as XLSX from 'xlsx';

import {
  Category,
  ImpactCo2Answer,
} from '@/domain/impact-co2/entities/question.entity';

import { TabsBuilder as TabsBuilder } from './tabs-builder';

type TabData = {
  [tabName: string]: string[][];
};

export class ExportReportExcelUtils {
  static export(filename: string, answers: ImpactCo2Answer[]) {
    const data = this.prepareData(answers);
    this.buildAndSaveXls(data, filename);
  }

  private static prepareData(answers: ImpactCo2Answer[]): TabData {
    const categoriesToExport: Category[] = [
      'ACCOMMODATION',
      'CATERING_BEVERAGE',
      'CATERING_MEAL',
      'MOBILITY',
      'TEAM_MOBILITY',
      'BUILDING',
      'BUILDING_HEATING',
      'CARGO',
      'DIGITAL',
      'ENERGY',
      'EQUIPMENT',
      'GENERATOR',
      'OFFICE_SUPPLIES_NEW',
      'OFFICE_SUPPLIES_REFURBISH',
      'RECYCLABLE_WASTE',
      'NON_RECYCLABLE_WASTE',
      'WATER',
      'MOBILITY_PUBLIC',
      'ACCOMMODATION_PUBLIC',
    ];
    const tabsBuilder = new TabsBuilder(answers);
    // prepare list of excel tabs
    // tab-name: name of category
    // tab-content: header an rows created with tabsBuilder
    const data: TabData = categoriesToExport.reduce((acc, category) => {
      const tabName = category;
      return { ...acc, [tabName]: tabsBuilder.build(category) };
    }, {});
    return data;
  }

  private static buildAndSaveXls(data: TabData, filename: string) {
    // create workbook
    const wb = XLSX.utils.book_new();
    Object.entries(data).forEach(([sheetName, sheetData]) => {
      // add sheet with data inside
      const ws = XLSX.utils.aoa_to_sheet(sheetData);
      // change cell widths
      const DEFAULT_CELL_WIDTH = 25;
      ws['!cols'] = [
        { wch: DEFAULT_CELL_WIDTH }, // category
        { wch: DEFAULT_CELL_WIDTH }, // sector
        { wch: DEFAULT_CELL_WIDTH }, // label
        { wch: DEFAULT_CELL_WIDTH }, // tags
        { wch: DEFAULT_CELL_WIDTH }, // external
        { wch: DEFAULT_CELL_WIDTH }, // extra column 1
        { wch: DEFAULT_CELL_WIDTH }, // extra column 2
        { wch: DEFAULT_CELL_WIDTH }, // extra column 3
        { wch: DEFAULT_CELL_WIDTH }, // extra column 4
        { wch: DEFAULT_CELL_WIDTH }, // extra column 5
      ];
      // add sheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    });
    // save workbook to file
    XLSX.writeFile(wb, filename);
  }
}
